// Copyright © 2021 Move Closer
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var BootstrapBadgeTheme;
(function (BootstrapBadgeTheme) {
    BootstrapBadgeTheme["Black"] = "black";
    BootstrapBadgeTheme["Blue"] = "blue";
    BootstrapBadgeTheme["Gray"] = "gray";
    BootstrapBadgeTheme["Green"] = "green";
    BootstrapBadgeTheme["Red"] = "red";
    BootstrapBadgeTheme["White"] = "white";
    BootstrapBadgeTheme["Yellow"] = "yellow";
})(BootstrapBadgeTheme || (BootstrapBadgeTheme = {}));
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var BootstrapBadgeSize;
(function (BootstrapBadgeSize) {
    BootstrapBadgeSize["Normal"] = "normal";
    BootstrapBadgeSize["Small"] = "small";
    BootstrapBadgeSize["Title"] = "title";
})(BootstrapBadgeSize || (BootstrapBadgeSize = {}));
